webpackJsonp([15],{

/***/ "JYNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__("gBtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_page_rank_scss__ = __webpack_require__("Tjrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_page_rank_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_css_page_rank_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_api_index__ = __webpack_require__("axEj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_common_index__ = __webpack_require__("4PxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_utils_index__ = __webpack_require__("EgtA");










function bindEvts() {
  memberFormInit();
  loadMoreGame();
}

function memberFormInit() {
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].closeForm.init();
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].loginFormInit({
    success: function success() {
      return Object(__WEBPACK_IMPORTED_MODULE_3_js_common_index__["l" /* headerInit */])();
    },
    form: '.yui-memberform0-login',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member'
  });
}

function keyWordsInit() {
  var list = document.querySelector('.list-keywords ul');
  if (!list) {
    __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e('[keyWordsInit] DOM element whose selector\'s .list-keywords ul not found');
    return;
  }

  var obj = list.querySelector('.selected');

  if (obj) {
    list.prepend(obj);
  }
}

function loadMoreGame() {
  var moreObj = document.querySelector('.yui-loadmore0');

  if (!moreObj) {
    __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e('[loadMoreGame] DOM element whose selector\'s .yui-loadmore0 not found.');
    return;
  }

  var target = document.querySelector('.sec-main .list');
  if (!target) {
    __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e('[loadMoreGame] DOM element whose selector\'s .sec-main .list not found.');
    return;
  }

  var pageIndex = 1;
  var loadGames = new __WEBPACK_IMPORTED_MODULE_3_js_common_index__["d" /* LoadGames */]({
    createNode: createNode
  });

  $(moreObj).one('click', handler);

  function handler() {
    loadGames.done(function () {
      $(moreObj).one('click', handler);
      pageIndex++;
    }).failed(function () {
      $(moreObj).one('click', handler);
    }).completed(function () {
      $(moreObj).remove();
    }).start({
      api: __WEBPACK_IMPORTED_MODULE_2_js_api_index__["f" /* getRank */],
      data: {
        columns: 'description,id,logofile,thumnaillogofile,link,name,score,tags,proscore,filesize',
        descLen: '160',
        pageIndex: pageIndex,
        pageSize: 20,
        rankCode: moreObj.getAttribute('data-rankcode'),
        type: moreObj.getAttribute('data-type')
      },
      loadingTxt: '正在加载...',
      moreObj: moreObj,
      target: target
    });
  }

  function createNode(o) {
    return $('\n      <li>\n        <a class="yui-card0halign" href="' + o.link + '">\n          <div class="yui-card0halign-iconbox">\n            <img src="' + ( true ? resourceprefix : SERVER_URL) + (o.thumnaillogofile ? o.thumnaillogofile : o.logofile) + '" alt="" onerror="_global.imgErrHandler(this)">\n          </div>\n          <div class="yui-card0halign-infobox">\n            <div class="high-layer">\n              <span class="icon-base">' + this.amt + '</span>\n              <span>' + o.name + '</span>\n            </div>\n            <div class="middle-layer">\n              <span class="slot-lft">' + o.tags + '</span>\n              <span class="slot-lft">' + (o.filesize || '--') + '</span>\n              <div class="' + Object(__WEBPACK_IMPORTED_MODULE_3_js_common_index__["m" /* hotJudge */])(o.proscore) + '">\n                <span>\u70ED\u5EA6' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(o.proscore) + '\u2103</span>\n                <svg class="icon yui-icon-flame0-red">\n                  <use xlink:href="#icon-flame0"></use>\n                </svg>\n              </div>\n            </div>\n            <div class="low-layer">' + o.description + '</div>\n          </div>\n          <div class="yui-card0halign-actionbox">\n            <svg class="icon yui-icon-arrow4-bluedown">\n              <use xlink:href="#icon-arrow4" href="#icon-arrow4"></use>\n            </svg>\n          </div>\n        </a>\n      </li>\n    ')[0];
  }
}

function rankListInit() {
  $('.yui-cranklist0').on('mouseenter', 'li', function () {
    $(this).addClass('selected').siblings('.selected').removeClass('selected');
  });
}

function uiInit() {
  keyWordsInit();
  rankListInit();
}

window._dataBus.get('domReadyObserver').subscribe(function () {
  uiInit();
  bindEvts();
});

/***/ }),

/***/ "Tjrw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["JYNm"]);


// WEBPACK FOOTER //
// js/rank.js